import globalAxios, { AxiosInstance } from "axios";
import { CodeApi, CommitteeApi, MemberApi, SystemApi, FileApi, Configuration } from "@/modules/typescript-cmpApi-client";
export const BASE_PATH = "/".replace(/\/+$/, "");

export class CMPApi {
  public CodeApi?: CodeApi;
  public committeeApi?: CommitteeApi;
  public memberApi?: MemberApi;
  public systemApi?: SystemApi;
  public fileApi?: FileApi;

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected axios: AxiosInstance = globalAxios
  ) {
    this.CodeApi = new CodeApi(configuration, basePath, axios);
    this.committeeApi = new CommitteeApi(configuration, basePath, axios);
    this.memberApi = new MemberApi(configuration, basePath, axios);
    this.systemApi = new SystemApi(configuration, basePath, axios);
    this.fileApi = new FileApi(configuration, basePath, axios);
  }
}